import { withReportsFromDay } from '@/common/time'
import { machineRankingQuery, WizardData as MachineRankingWizardData } from '../../machinesranking/wizard/Model'

export interface WizardData extends MachineRankingWizardData {}

export const cleanWizardData = (): WizardData => {
  const from = new Date()
  from.setDate(from.getDate() - 1)
  from.setHours(0, 0, 0, 0)
  const to = new Date(from)
  to.setHours(23, 59, 0, 0)
  return withReportsFromDay({ from, to, selectMachines: false, selectedMachineIds: null })
}

// Keep the same dates and machine scope for the view and both export formats.
export const fleetReportQuery = machineRankingQuery
